import { Png } from "common/assets";
import { CertificateItem } from "./CertificatesItem";
import { items } from "./data";
import {
    StyledListCertificates,
} from "./styled";
import { TCertificate } from "./types";

export const ListСertificates = () => {
    return (
        <StyledListCertificates>
            {items.map((item: TCertificate, index: number) => (
                <CertificateItem key={index} item={item} />
            ))}
        </StyledListCertificates>
    );
};
